import { cn, formatCdnImg } from "@drpcrd/utils";
import Image, { StaticImageData } from "next/image";
import { ClassNameValue } from "tailwind-merge";
import { Briefcase } from "lucide-react";

type Props = {
  logo: string | StaticImageData | null;
  className?: ClassNameValue;
  size?: "sm" | "lg";
};

const defaultClasses: ClassNameValue =
  "overflow-hidden rounded-full border-1 border-neutral-500 bg-primary-50";

const iconSizeClasses = {
  sm: "h-2.5 w-2.5",
  lg: "h-4 w-4",
};

export const CampaignAvatar = ({ logo, className, size = "sm" }: Props) => {
  if (logo == null || logo === "") {
    return (
      <div
        className={cn(
          "flex items-center justify-center p-1",
          defaultClasses,
          className,
        )}
      >
        <Briefcase className={cn(iconSizeClasses[size], "text-primary")} />
      </div>
    );
  }

  // If it's a StaticImageData object, use it directly
  // Otherwise, format as CDN image
  const imageSrc = typeof logo === "string" ? formatCdnImg(logo) : logo;

  return (
    <Image
      src={imageSrc}
      width={64}
      height={64}
      alt="Brand logo"
      className={cn("object-cover", defaultClasses, className)}
      quality={95}
    />
  );
};
